import React from 'react'

const cities = [
    { name: "Ahmedabad", icon: "🏙️" },
    { name: "Amritsar", icon: "🏙️" },
    { name: "Bengaluru", icon: "🏙️" },
    { name: "Bhopal", icon: "🏙️" },
    { name: "Chandigarh", icon: "🏙️" },
    { name: "Chennai", icon: "🏙️" },
    { name: "Coimbatore", icon: "🏙️" },
    { name: "Dehradun", icon: "🏙️" },
    { name: "Delhi", icon: "🏙️" },
    { name: "Goa", icon: "🏙️" },
    { name: "Hyderabad", icon: "🏙️" },
    { name: "Jaipur", icon: "🏙️" },
    { name: "Kochi", icon: "🏙️" },
    { name: "Kolkata", icon: "🏙️" },
    { name: "Lucknow", icon: "🏙️" },
    { name: "Mumbai", icon: "🏙️" },
    { name: "Nagpur", icon: "🏙️" },
    { name: "Patiala", icon: "🏙️" },
    { name: "Pimpri-Chinchwad", icon: "🏙️" },
    { name: "Pune", icon: "🏙️" },
    { name: "Vadodara", icon: "🏙️" },
    { name: "Vizag", icon: "🏙️" }
];
const Cityservice = () => {
  return (
    <div className='bg-slate-50'>
        <div className='text-center text-3xl font-bold'>
            <p className='pt-10'>Top-Quality Pet Services Now in Your City</p>
        </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 p-6 pt-10 cursor-pointer">
            {cities.map((city, index) => (
                <div
                    key={index}
                    className="bg-white shadow-lg rounded-lg p-4 flex items-center justify-center hover:bg-indigo-100 transition"
                >
                    <span className="text-3xl mr-2">{city.icon}</span>
                    <span className="text-lg font-semibold text-gray-800">{city.name}</span>
                </div>
            ))}
        </div>
        <div>
            
        </div>
    </div>
  )
}

export default Cityservice
